import { useTranslation } from 'react-i18next';

import { Button } from '@nvision/ui';

import { InfiniteScroll } from '@/components/infinite-scroll';
import { Page } from '@/components/page';

import { useSuspenseProjects } from '../../hooks';
import { ProjectCard } from './project-card';
import { ProjectsControls } from './projects-controls';

import styles from './projects.module.css';

const SCROLL_OFFSET = 200;

export const Projects: React.FC = () => {
  const { data: projects, fetchNextPage, hasNextPage, isFetchingNextPage } = useSuspenseProjects();
  const { t } = useTranslation();

  return (
    <Page>
      <Page.SideBar>
        <Page.SideBar.Header title="Project Search" />
        <Page.SideBar.Main></Page.SideBar.Main>
        <Page.SideBar.Footer>
          <Button secondary size="sm">
            {t('translation:default.buttons.clear')}
          </Button>
          <Button type="submit" size="sm" primary>
            {t('translation:default.buttons.search')}
          </Button>
        </Page.SideBar.Footer>
      </Page.SideBar>
      <Page.Main>
        <ProjectsControls />
        <InfiniteScroll
          className={styles.list}
          hasMore={hasNextPage}
          isLoading={isFetchingNextPage}
          loadMore={fetchNextPage}
          scrollOffset={SCROLL_OFFSET}
        >
          {projects.items.map((project) => (
            <ProjectCard key={project.projectId} project={project} />
          ))}
        </InfiniteScroll>
      </Page.Main>
    </Page>
  );
};
